<template>
    <div class="kt-portlet kt-portlet--height-fluid">
        <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title" @click.prevent.stop="toggle">{{title}}</h3>
            </div>
            <div class="kt-portlet__head-toolbar" @click="toggle">
                <ul :class="classType" role="tablist">
                    <li  class="nav-item" v-for="(tab, key) in tabs" :key="key">
                        <a :class="['nav-link', {'active': tab.isActive}]" data-toggle="tab" role="tab" :href="tab.url" @click.prevent="selectab(tab)"><i :class="'flaticon2-'+ tab.icon"></i> {{tab.name}}</a></li>
                </ul>
            </div>
        </div>
        <div class="kt-portlet__body">
            <div class="tab-content"><slot></slot></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, required: true },
        type: { type: String, default: "" }
    },
    data() {
        return {
            tabs: [],
            isHidden: false
        };
    },
    computed: {
        classType() {
            return this.type === "pill"
                ? `nav nav-pills nav-pills-sm nav-pills-label nav-pills-bold`
                : `nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-brand ${
                    this.type
                }`; //nav-tabs-line-3x nav-tabs-space-lg nav-tabs-space-xl
        }
    },
    methods: {
        toggle() {
            this.isHidden = !this.isHidden;
        },
        selectab(object) {
            for (const obj of this.tabs) obj.isActive = obj.name === object.name;
        }
    },
    created() {
        this.tabs = this.$children;
    },
}
</script>